import React from "react";
import { Card, CardContent, Box, Typography } from "@mui/material";

function KpiCard({ title, value, subtitle, icon: Icon, trend, trendValue }) {
	return (
		<Card sx={{ borderRadius: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", border: "1px solid #dfe3e8", height: "100%" }}>
			<CardContent sx={{ p: 2.5, height: "100%", "&:last-child": { pb: 2.5 } }}>
				<Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
					<Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 0.5 }}>
						<Typography variant="caption" sx={{ fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", color: "#8e9bae", fontSize: "0.65rem" }}>
							{title}
						</Typography>
						<Typography variant="h5" sx={{ fontWeight: 700, color: "#0f4557", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
							{value}
						</Typography>
						{subtitle && (
							<Typography variant="caption" sx={{ color: "#8e9bae", fontSize: "0.7rem" }}>
								{subtitle}
							</Typography>
						)}
						{trend && trendValue && (
							<Typography variant="caption" sx={{
								fontWeight: 600,
								fontSize: "0.7rem",
								color: trend === "up" ? "#16a34a" : trend === "down" ? "#dc2626" : "#8e9bae",
							}}>
								{trend === "up" ? "↑" : trend === "down" ? "↓" : "→"} {trendValue}
							</Typography>
						)}
					</Box>
					{Icon && (
						<Box sx={{ bgcolor: "#1a9e8f15", borderRadius: "12px", p: 1.25, display: "flex", alignItems: "center", justifyContent: "center" }}>
							{React.cloneElement(Icon, { sx: { color: "#1a9e8f", fontSize: 22 } })}
						</Box>
					)}
				</Box>
			</CardContent>
		</Card>
	);
}

export default KpiCard;
